import { foreignSupportAddressNameFields } from 'constants/enums/people';
import { ValidateJSModel } from 'forms/shared/types';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { hasYesOrNo } from 'models/validate';
import { ForeignActivitiesOnGoingSupportModel } from './types';
import { foreignActivitiesOnGoingSupportItemValidator } from './validators/item';

const foreignActivitiesOnGoingSupportValidator: ValidateJSModel<ForeignActivitiesOnGoingSupportModel> = {
  HasOnGoingForeignSupport: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes, attributeName, options) => {
    if (attributes?.HasOnGoingForeignSupport?.value === 'Yes') {
      let additionalValidation: any = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, foreignSupportAddressNameFields);

      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.relatives.error.duplicateListItems',
          }
        };
      }

      return {
        ...additionalValidation,
        presence: true,
        accordion: { validator: foreignActivitiesOnGoingSupportItemValidator },
      };
    }

    return {};
  },
};
export default foreignActivitiesOnGoingSupportValidator;
